import { IconWrapper } from '../runtime';
export default IconWrapper('loading_white', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-regular{stroke-width:var(--kd-stroke-width-icon-regular, 1px); }.kd-color-icon-white{color:#ffffff; color:var(--kd-color-icon-white, #ffffff); }']), h("g", {
    "class": "kd-stroke-width-icon-regular kd-color-icon-white"
  }, [h("path", {
    "attrs": {
      "d": "M8 14C9.09286 14 10.1175 13.7078 11 13.1973",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none",
      "stroke": 'url(#' + props.id + '0f248b78' + ')',
      "vector-effect": "non-scaling-stroke"
    }
  })]), h("g", {
    "class": "kd-stroke-width-icon-regular kd-color-icon-white"
  }, [h("path", {
    "attrs": {
      "d": "M8 2C11.3137 2 14 4.6863 14 7.99996C14 10.2208 12.7934 12.1598 11 13.1973",
      "stroke-linejoin": "round",
      "fill": "none",
      "stroke": 'url(#' + props.id + '0f248b78' + ')',
      "vector-effect": "non-scaling-stroke"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '0f248b78',
      "x1": "8",
      "y1": "12",
      "x2": "8",
      "y2": "3",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "currentColor"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "currentColor",
      "stop-opacity": "0.5"
    }
  })])])]), h("g", {
    "class": "kd-stroke-width-icon-regular kd-color-icon-white"
  }, [h("path", {
    "attrs": {
      "d": "M8 2C4.68629 2 2 4.6863 2 8C2 11.3137 4.68629 14 8 14",
      "stroke-linejoin": "round",
      "fill": "none",
      "stroke": 'url(#' + props.id + 'd764a728' + ')',
      "vector-effect": "non-scaling-stroke"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'd764a728',
      "x1": "7.5",
      "y1": "14",
      "x2": "8",
      "y2": "3",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "currentColor",
      "stop-opacity": "0"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "currentColor",
      "stop-opacity": "0.5"
    }
  })])])])]);
});